var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-listing-table-actions" },
    [
      _c(
        "CompassMenu",
        {
          ref: "refMenuActions",
          attrs: {
            trigger: "click",
            customClass: "automation-listing-table-actions__menu"
          },
          scopedSlots: _vm._u([
            {
              key: "dropdown",
              fn: function() {
                return [
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.$t.__("common.actions.rename"),
                      "data-bot": "automation-listing__submenu--rename"
                    },
                    on: { click: _vm.handleRename }
                  }),
                  _vm._v(" "),
                  !_vm.isWizardAutomation
                    ? _c("CompassMenuItem", {
                        attrs: {
                          label: _vm.$t.__("common.actions.edit"),
                          disabled: !_vm.canAccessBuilder,
                          "data-bot": "automation-listing__submenu--update"
                        },
                        on: { click: _vm.handleEdit }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.$t.__("common.actions.duplicate"),
                      "data-bot": "automation-listing__submenu--duplicate"
                    },
                    on: { click: _vm.handleDuplicate }
                  }),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.$t.__("common.actions.delete"),
                      "data-bot": "automation-listing__submenu--delete"
                    },
                    on: { click: _vm.handleDelete }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [_c("CompassIconButton", { attrs: { icon: "action" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }